import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogActions, MatDialogContent } from '@angular/material/dialog';
import { Component, Inject, OnInit} from '@angular/core';
import { NgIf } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { TasklistService } from '../services/tasklist.service'
import { MatIcon } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-task-list-download-dialog',
  imports: [MatDialogTitle, NgIf, MatDialogActions, MatButton, MatIcon, MatProgressSpinnerModule, MatDialogContent],
  templateUrl: './task-list-download.component.html',
  //styleUrl: './excel-download-dialog.component.scss'
})
export class TaskListDownloadDialog implements OnInit {

    info: download_info = {site:'', environment:'', objectID:''};
    printRequested: boolean = true;
    s3_download_link: string = '';
    error_message: string = '';
    s3_filename: string = '';

    constructor(
        private service: TasklistService,
        public dialogRef: MatDialogRef<TaskListDownloadDialog>,
        @Inject(MAT_DIALOG_DATA) public DownloadInfo: download_info) {
          
    }

    ngOnInit(){
      this.info.site = this.DownloadInfo.site ? this.DownloadInfo.site: '';
      this.info.environment = this.DownloadInfo.environment ? this.DownloadInfo.environment: '';
      this.info.objectID = this.DownloadInfo.objectID ? this.DownloadInfo.objectID: '';
      this.service.getExcelS3DownloadLink(this.DownloadInfo.site, this.DownloadInfo.environment, this.DownloadInfo.objectID).subscribe(
        result => {
            this.error_message = result.ErrorMessage.toString();
            if(this.error_message === ''){
                this.s3_download_link = result.Body.download_url;
                this.s3_filename = result.Body.filename;
            }
            this.printRequested = false;
      })
    }

    onNoClick(): void {
      this.dialogRef.close();
    }

    downloadFile() {
        this.printRequested = true;
        this.service.getExcelFile(this.s3_download_link).subscribe(
            (blob) => {
                saveAs(blob, this.s3_filename);
                this.printRequested = false;
            }
        )
    }

}

export interface download_info {
  site: string;
  environment: string;
  objectID: string;
}